import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalService } from '../../shared/swal.service';
import { UserModel } from '../../model/user.model';

export const ServerErrorMessage = 'Server đang lỗi. Thử lại sau';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private swalService: SwalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  submit() {
    this.spinner.show();
    const formValue = this.form.value;

    this.userService.login(formValue).subscribe((user: UserModel) => {
      this.spinner.hide();
      if (user) {
        localStorage.setItem('dttd-user', JSON.stringify({
          id: user.id,
          username: user.username,
        }));
        this.router.navigate(['/admin/dashboard']);
      } else {
        this.spinner.hide();
        this.swalService.openErrorMessage('Sai tài khoản hoặc mật khẩu');
      }
    }, () => {
      this.spinner.hide();
      this.swalService.openErrorMessage(ServerErrorMessage);
    });
  }

}
